import { Component, Inject, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { GestockService } from '../services/gestock.service';

import html2pdf from 'html2pdf.js';


@Component({
  selector: 'app-detail-commande',
  templateUrl: './detail-commande.component.html',
  styleUrls: ['./detail-commande.component.css']
})
export class DetailCommandeComponent implements OnInit {


	lignedecommande : any ;

  customer: any;
  items: any[] = [];
  allQtsOnCart: any[] = [];
  factureId: string = '';
  date: string ;

  @ViewChild('factureContent') factureContent!: ElementRef;

  constructor(public dialogRef: MatDialogRef<DetailCommandeComponent>, public dialog: MatDialog, private configServer: GestockService, 
           private _adapter: DateAdapter<any>, @Inject(MAT_DATE_LOCALE) private _locale: string,
           @Inject(MAT_DIALOG_DATA) public data: any ) { 

      this.lignedecommande = data.element;
      console.log(this.lignedecommande) ;
	  this.customer = JSON.parse(this.lignedecommande.infosClient) ;
	  this.items = JSON.parse(this.lignedecommande.panier);
	  this.allQtsOnCart = JSON.parse(this.lignedecommande.qtes) ;
	  this.factureId = this.lignedecommande.Numcmd ;
	  this.date = this.lignedecommande.DateCmd;
  }

  ngOnInit(): void {
  }


  get total(): number {
    return this.lignedecommande.MontantCmd ; //this.items.reduce((sum, item, index) => sum + this.allQtsOnCart[index] * item.prix, 0);
  }

  imprimer() {
    this.factureContent.nativeElement.print();
  }

  imprimerSection() {
    const printContent = this.factureContent.nativeElement.innerHTML;
    const WindowPrt = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
    if (WindowPrt) {
      WindowPrt.document.write(`
        <html>
          <head>
            <title>Facture</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 20px; }
              table { width: 100%; border-collapse: collapse; }
              th, td { padding: 8px; border: 1px solid #ddd; text-align: left; }
              h2, h3, p { margin: 0 0 10px; }
            </style>
          </head>
          <body onload="window.print(); window.close()">
            ${printContent}
          </body>
        </html>
      `);
      WindowPrt.document.close();
    }
  }

  formatMoney(montant: any){
    let dollarUSLocale = Intl.NumberFormat('fr-FR');
    return dollarUSLocale.format(montant) ;
  }

  exporterPDF() {
    const options = {
      margin:       10,
      filename:     `facture-${this.factureId}.pdf`,
      /*image:        { type: 'jpeg', quality: 0.98 },*/
      html2canvas:  { scale: 2 },
      jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    html2pdf().from(this.factureContent.nativeElement).set(options).save();
  }

  fermerDialog(){
  	this.dialogRef.close();
  }


  fermerLeProcessusDeCommande() {
    //this.factureRetourInfoEvent.emit(1);
  }



}
